export var FeatureChangeAction;
(function (FeatureChangeAction) {
    FeatureChangeAction["Add"] = "ADD";
    FeatureChangeAction["Remove"] = "REMOVE";
})(FeatureChangeAction || (FeatureChangeAction = {}));
/**
 * TypeGuard to check if a object is realy a {@lnk EquipmentChange}
 *
 * @param object any
 * @returns
 */
export function isEquipmentChange(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('id' in object))
        return false;
    if (!('action' in object))
        return false;
    return true;
}
/**
 * TypeGuard to check if a object is realy a {@lnk ModelChange}
 *
 * @param object any
 * @returns
 */
export function isModelChange(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('id' in object))
        return false;
    var id = object.id;
    if (!id)
        return false;
    if (typeof id !== 'object')
        return false;
    if (!('code' in id))
        return false;
    if (!('version' in id))
        return false;
    if (!('year' in id))
        return false;
    return true;
}
/**
 * TypeGuard to check if a object is realy a {@lnk EquipmentChange}
 *
 * @param object any
 * @returns
 */
export function isTrimlineChange(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('id' in object))
        return false;
    if ('action' in object)
        return false;
    var id = object.id;
    if (!id)
        return false;
    if (typeof id === 'object')
        return false;
    return true;
}
/**
 * TypeGuard to check if a object is realy a {@lnk ConfiguredCar }
 *
 * @param object any
 * @returns
 */
export function isConfiguredCar(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('id' in object))
        return false;
    if (!('carline' in object))
        return false;
    return true;
}
/**
 * TypeGuard to check if a object is realy a {@lnk AudiCodeError }
 *
 * @param object any
 * @returns
 */
export function isAudiCodeError(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('code' in object))
        return false;
    if (!('message' in object))
        return false;
    return true;
}
/**
 * TypeGuard to check if a object is a viable carId
 *
 * @param object
 * @returns
 */
export function isCarId(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('brand' in object))
        return false;
    if (!('country' in object))
        return false;
    if (!('language' in object))
        return false;
    if (!('model' in object))
        return false;
    if (!('salesGroup' in object))
        return false;
    return true;
}
/**
 * TypeGuard to check if a object is a viable carId
 *
 * @param object
 * @returns
 */
export function isCarlineInput(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('brand' in object))
        return false;
    if (!('country' in object))
        return false;
    if (!('language' in object))
        return false;
    if (!('carlineId' in object))
        return false;
    return true;
}
export function isfinancingInput(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('product' in object))
        return false;
    if (!('productParameters' in object))
        return false;
    return true;
}
/**
 * The event types that the subscribers get notified for.
 * - FETCHING_DATA: Will trigger just before the oneGraph query is send
 * - NEW_DATA: Will trigger as soon as oneGraph successfully responded with data
 */
// eslint-disable-next-line no-shadow
export var StateEvents;
(function (StateEvents) {
    StateEvents["FETCHING_DATA"] = "FETCHING_DATA";
    StateEvents["NEW_DATA"] = "NEW_DATA";
    StateEvents["ERROR"] = "ERROR";
})(StateEvents || (StateEvents = {}));
export function isSpecificCarData(object) {
    if (!object)
        return false;
    if (typeof object !== 'object')
        return false;
    if (!('configuredCar' in object))
        return false;
    return true;
}
//# sourceMappingURL=types.js.map